import { render, staticRenderFns } from "./FixedPointDetails.vue?vue&type=template&id=281251ba&scoped=true"
import script from "./FixedPointDetails.vue?vue&type=script&lang=js"
export * from "./FixedPointDetails.vue?vue&type=script&lang=js"
import style0 from "./FixedPointDetails.vue?vue&type=style&index=0&id=281251ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281251ba",
  null
  
)

export default component.exports